import React, { Fragment } from "react";

import {
  PDFViewer,
  PDFDownloadLink,
  Document,
  Page,
  Text,
  View,
  Image,
  Link,
} from "@react-pdf/renderer";

import styles from "./styles";

import CONFIG from "../../../config";
const { logo, logo_pdf, footer_pdf } = CONFIG.setup.assets;
const currentTime = new Date();
const year = currentTime.getFullYear();

const footer = ({ order }) => {
  return (
    <Fragment>
      <View style={styles.container}>
        <View style={styles.line}></View>
      </View>


      <View wrap={false} style={[styles.container, styles.otherWrapper, { marginTop: "auto" }]}>
        <View style={[styles.otherContainer, { flex: 1 }]}>
          <View style={[styles.line, { marginTop: 5, marginBottom: 8 }]}></View>
          <View style={styles.columnDirection}>
            <Text style={styles.DefaultNameLarge}>Collection Confirmation</Text>
            <Text style={styles.DefaultName}>
              I acknowledge receipt of the Gift Cards listed above.
            </Text>
            <Text style={[styles.DefaultName, { marginTop: 10 }]}>
              Name (Print): ________________________________
            </Text>
            <Text style={styles.DefaultName}>
              Signature: ________________________________
            </Text>
            <Text style={styles.DefaultName}>
              Date Collected: _____ / _____ / _____
            </Text>
          </View>
        </View>

        <View style={[styles.otherContainer, { flex: 1 }]}>
          <View style={[styles.line, { marginTop: 5, marginBottom: 8 }]}></View>
          <View style={styles.columnDirection}>
            <Text style={styles.DefaultNameLarge}>Staff Use Only</Text>
            <Text style={[styles.DefaultName, styles.defaultBold, { marginTop: 10 }]}>
              [ ] Government-issued ID sighted and verified
            </Text>
            <Text style={[styles.DefaultName, { marginTop: 10 }]}>
              Processed by: ________________________________
            </Text>
            <Text style={[styles.DefaultName, { marginTop: 10 }]}>
              Centre / Location: ________________________________
            </Text>
          </View>
        </View>
      </View>

      {/* <View wrap={false} style={[styles.container, styles.footerWrapper]}>
        <View style={styles.footerContainer}>

          <View style={[styles.footerMainBg]}>
            <Image style={styles.lineFooter} src={footer_pdf} />
          </View>

          <View style={[styles.footerMain]}>
            <View style={styles.footerLinksSection}>
              <View style={styles.footerLinksRow}>
                <Link style={[styles.footerLink, styles.footerLinkItem]} src="https://giftcards.westfield.co.nz/page/contact">
                  Contact Us
                </Link>
                <Link style={[styles.footerLink, styles.footerLinkItem]} src="https://www.westfield.co.nz/privacy-policy">
                  Privacy Policy
                </Link>
                <Link style={[styles.footerLink, styles.footerLinkItem]} src="https://www.westfield.co.nz/terms-and-conditions">
                  Terms and Conditions
                </Link>
                <Link style={[styles.footerLink, styles.footerLinkItem]} src="http://www.scentregroup.com/">
                  @ {year} Scentre Group
                </Link>
              </View>
            </View>
            <View style={styles.footerLinksDivider} />
          </View>

        </View>
      </View> */}
    </Fragment >
  );
};

export default footer;
